/**
 * Make carousels out of product li elements.
 * Use Owl or Slick depending on Template.
 */
export const makeProductsCarousel = () => {
  if (pulpo.isCibTemplate) {
    makeProductsSlick();
    return;
  } else if (pulpo.isLooksTemplate) {
    helpers.makeCollectionProductSlick();
    return;
  }

  $('.products').owlCarousel({
    loop: false,
    margin: 20,
    responsiveClass: true,
    pagination: false,
    dots: false,
    nav: true,
    navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
    responsive: {
      0: {
        items: 2,
      },
      600: {
        items: 3,
      },
      1000: {
        items: 4,
      },
    },
  });
};

/**
 * Make Slick carousel out of product li elements.
 */
const makeProductsSlick = () =>
  $('.products').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    swipeToSlide: true,
    nextArrow: '<i class="fas fa-chevron-right"></i>',
    prevArrow: '<i class="fas fa-chevron-left"></i>',
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });
